export const checkResponse = async (response: Response) => {
  if (!response.ok) {
    const errorDetails = await response.json().catch(() => null);
    throw new Error(
      errorDetails?.message || `HTTP error! status: ${response.status}`
    );
  }
  return response.json();
};

/** Prod UI host: custom domain, or temporary CloudFront until DNS cutover. */
const PROD_HOSTNAMES = new Set([
  "servicedesk.csaiautomations.com",
  "d1cyod1vfw4e8l.cloudfront.net",
]);

export const isProdHost = (
  hostname: string = window.location.hostname,
): boolean => PROD_HOSTNAMES.has(hostname);

/** True when the SPA is served from the production host. */
export const isProd = isProdHost();

const ALLOWED_PO_CLOSURE_EMAIL_DOMAINS = [
  "@trilogy.com",
  "@ignitetech.com",
  "@vrya.com",
] as const;

export const isAllowedPoClosureRequesterEmail = (email?: string): boolean => {
  if (typeof email !== "string") {
    return false;
  }

  const normalizedEmail = email.trim().toLowerCase();
  return ALLOWED_PO_CLOSURE_EMAIL_DOMAINS.some((domain) =>
    normalizedEmail.endsWith(domain),
  );
};

export const getNetSuiteLink = (
  type:
    | "Subscription"
    | "Invoice"
    | "Quote"
    | "PurchaseOrder"
    | "CreditMemo"
    | "Journal"
    | "AdvIntercompanyJournal"
    | "Customer"
    | "BillingAccount"
    | "Item"
    | "SubscriptionPlan"
    | "PricePlan"
    | "PriceBook",
  id: string | number
) => {
  const baseUrl = isProdHost()
    ? "https://4914352.app.netsuite.com"
    : "https://4914352-sb2.app.netsuite.com";

  let path: string;

  switch (type) {
    case "Subscription":
      path = `/app/accounting/subscription/subscription.nl?id=${id}`;
      break;
    case "Invoice":
      path = `/app/accounting/transactions/custinvc.nl?id=${id}`;
      break;
    case "Quote":
      path = `/app/accounting/transactions/estimate.nl?id=${id}`;
      break;
    case "PurchaseOrder":
      path = `/app/accounting/transactions/purchord.nl?id=${id}`;
      break;
    case "CreditMemo":
      path = `/app/accounting/transactions/custcred.nl?id=${id}`;
      break;
    case "Journal":
      path = `/app/accounting/transactions/journal.nl?id=${id}`;
      break;
    case "AdvIntercompanyJournal":
      path = `/app/accounting/transactions/icjournal.nl?id=${id}`;
      break;
    case "Customer":
      path = `/app/common/entity/custjob.nl?id=${id}`;
      break;
    case "BillingAccount":
      path = `/app/accounting/otherlists/billingaccount.nl?id=${id}`;
      break;
    case "Item":
      path = `/app/common/item/item.nl?id=${id}`;
      break;
    case "SubscriptionPlan":
      path = `/app/common/item/item.nl?id=${id}`;
      break;
    case "PricePlan":
      path = `/app/accounting/subscriptionbilling/priceplan.nl?id=${id}`;
      break;
    case "PriceBook":
      path = `/app/accounting/subscriptionbilling/pricebook.nl?id=${id}`;
      break;
  }

  return `${baseUrl}${path}`;
};

export { displayJournalType, displayNsStatusName } from "models/journal-approval";
